<script>
    import { onMount } from "svelte";
    import loader from "@beyonk/async-script-loader";
    import { gaStore } from "./store.js";

    /** @type {boolean} */
    export let cookieConsent = false;
    export let properties;
    export let configurations = {};
    let initialized = false;

    $: updateConsent(cookieConsent);

    onMount(() => {
        init();
    });

    export function init() {
        const mainProperty = properties[0];
        loader(
            [
                {
                    type: "script",
                    url: `//www.googletagmanager.com/gtag/js?id=${mainProperty}`,
                },
            ],
            test,
            callback,
        );
    }

    /**
     * @param {boolean} consent
     */
    function updateConsent(consent) {
        if (!initialized) {
            return;
        }
        const type = consent ? "granted" : "denied";
        gtag("consent", "update", {
            ad_storage: type,
            ad_user_data: type,
            ad_personalization: type,
            analytics_storage: type,
        });
    }

    function test() {
        return Boolean(window.dataLayer).valueOf() && Array.isArray(window.dataLayer);
    }

    function gtag() {
        window.dataLayer.push(arguments);
    }

    function callback() {
        window.dataLayer = window.dataLayer || [];
        initialized = true;
        gtag("js", new Date());
        const consentType = cookieConsent ? "granted" : "denied";
        gtag("consent", "default", {
            ad_storage: consentType,
            ad_user_data: consentType,
            ad_personalization: consentType,
            analytics_storage: consentType,
        });
        properties.forEach((p) => {
            gtag("config", p, configurations[p] || {});
        });

        return gaStore.subscribe((queue) => {
            let next = queue.length && queue.shift();

            while (next) {
                const { type, event, data } = next;
                gtag(type, event, data);
                next = queue.shift();
            }
        });
    }
</script>
